<!-- Loading bar -->
<!--<fuse-loading-bar></fuse-loading-bar>-->
<app-loader></app-loader>

<!-- Navigation -->
<fuse-vertical-navigation class="light bg-white print:hidden"
                          [mode]="isScreenSmall ? 'over' : 'side'"
                          [name]="'mainNavigation'"
                          [navigation]="navigation.default"
                          [appearance]="navigation_appearance"
                          [opened]="!isScreenSmall">
  <!-- Navigation header hook -->
  <ng-container fuseVerticalNavigationContentHeader>
    <!-- Logo -->
    <div class="flex items-center h-20 p-6 pb-6">
      <!--Light version-->
      <img class="dark:hidden"
           *ngIf="navigation_appearance!='thin'"
           src="assets/images/logos/logo-light.svg?v=2" style="width:160px;"
           alt="Logo image">
      <!--Dark version-->
      <img class="hidden dark:flex"
           *ngIf="navigation_appearance!='thin'"
           src="assets/images/logos/logo-dark.svg?v=2" style="width:160px;"
           alt="Logo image">

      <!--<img *ngIf="navigation_appearance=='thin'"
           src="assets/images/logos/logo-sidebar-small.svg"
           alt="Logo image"
           style="width:42px;height:42px;">-->
      <img class="dark:hidden" *ngIf="navigation_appearance=='thin'"
           src="assets/images/logos/logo-sidebar-small.svg?v=3"
           alt="Logo image">
      <!--<img class="hidden dark:flex" *ngIf="navigation_appearance=='thin'"
           src="assets/images/logos/logo-sidebar-small-dark.svg?v=3"
           alt="Logo image">-->

    </div>
  </ng-container>
  <ng-container NavigationModule>
    <!--<navigation-add-module></navigation-add-module>-->
  </ng-container>
</fuse-vertical-navigation>

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0">

    <!-- Header -->
    <div class="relative flex flex-0 items-center w-full h-16 px-4 md:px-6 z-49 border-b dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden">
        <!-- Navigation toggle button -->
        <button
            mat-icon-button
            (click)="toggleNavigation('mainNavigation')" data-case-id="main_navigation_mat_draw">
            <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
        </button>
        <!-- Components -->
        <div class="flex items-center pl-2 ml-auto space-x-0.5 sm:space-x-2">

          <div mat-button class="hidden sm:block" *ngIf="ges_system== false && show_offer_button == true && pending_invoice==false && type==1">
            <div style="font-size: 10px; float: left; margin: 12px; line-height: 15px;">{{'Specialofferends' | translate}}<br /> in <span style=" color: #ff5722;">{{offer_days_left}}</span></div>
            <button mat-stroked-button style="background: #fff5e8; line-height: 1px !important; margin-top: 8px;" [routerLink]="'/subscription/subscription-details'"><span style="font-size: 10px;">{{'SpecialOffer' |translate}}</span><br />{{'UpgradeNow' |translate}}</button>
          </div>

          <div mat-button class="hidden sm:block" *ngIf="ges_system== false && yearly_offer_button == true && pending_invoice==false && type==1">
            <button mat-stroked-button style="background: #fff5e8;line-height: 1px !important;" [routerLink]="'/subscription/subscription-details'"><span style="font-size: 10px;">{{'SpecialOffer' |translate}}</span><br />{{'Get30%OFF' |translate}}</button>
          </div>

          <div mat-button class="hidden sm:block" *ngIf="ges_system== false && pending_invoice==true && type==1">
            <button mat-stroked-button style="background: #fff5e8;line-height: 1px !important;" [routerLink]="'/subscription/invoice'"><span style="font-size: 10px;">{{'PendingInvoice' | translate}}</span><br />{{'PayNow'|translate}}</button>
          </div>


          <!--<languages></languages>-->
          <fuse-fullscreen class="hidden sm:block"></fuse-fullscreen>


    

          <shortcuts matTooltip="{{'Help' |translate}}"></shortcuts>
          <!--<messages></messages>-->
          <notifications matTooltip="{{'Activity' |translate}}" style="margin-right:10px!important"></notifications>
          <!--<button
      class="lg:hidden"
      mat-icon-button
      (click)="quickChat.toggle()">
      <mat-icon [svgIcon]="'heroicons_outline:chat-bubble-left-right'"></mat-icon>
  </button>-->
          <user></user>
        </div>
    </div>

    <!-- Content -->
    <div class="flex flex-col flex-auto">
        <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
        <router-outlet *ngIf="true"></router-outlet>
    </div>

    <!-- Footer -->
    <!--<div class="relative flex flex-0 items-center justify-start w-full h-14 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden">
        <span class="font-medium text-secondary">Fuse &copy; {{currentYear}}</span>
    </div>-->

</div>

<!-- Quick chat -->
<!--<quick-chat #quickChat="quickChat"></quick-chat>-->
